import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import ImavenLoadingScreen from '../Components/Helpers/loading-screen';
import useAuthenticatedAxios from './AuthenticatedAxios';

/**
 * DeveloperRoute — gates a route to DEVELOPERS only (Brain Test Bench).
 * Authoritative check is server-side: GET /testbench/access returns { isDeveloper } computed
 * from the ADMIN_* env allowlist OR the Expert's isDeveloper flag (toggled from the CRM).
 * Non-developers are redirected home. (This is UX; the /testbench APIs enforce it too.)
 */
const DeveloperRoute = ({ children }) => {
  const { isLoading } = useAuth0();
  const axios = useAuthenticatedAxios();
  const navigate = useNavigate();
  const [isDev, setIsDev] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let active = true;
    if (isLoading) return;
    axios.get('/testbench/access')
      .then(res => { if (active) { setIsDev(!!res.data?.isDeveloper); setChecking(false); } })
      .catch(() => { if (active) { setIsDev(false); setChecking(false); } });
    return () => { active = false; };
  }, [axios, isLoading]);

  useEffect(() => {
    if (!checking && !isDev) navigate('/');
  }, [checking, isDev, navigate]);

  if (isLoading || checking) return <ImavenLoadingScreen />;
  return isDev ? children : <ImavenLoadingScreen />;
};

export default DeveloperRoute;
